import React from "react";

const Weather = ({
	currenttime,
	cityname,
	citycountry,
	icon,
	temprature,
	weather,
}) => {
	return (
		<div>
			<div className="img">
				<h4>{currenttime}</h4>

				<h2>
					{cityname},{citycountry}
				</h2>

				<h1 style={{ fontSize: "90px" }}>
					<div>{<img src={icon} alt="icon" />}</div>
					{temprature}°C
				</h1>

				<h2>{weather}</h2>
			</div>
		</div>
	);
};

export default Weather;
